'use client'

import React from 'react'
import { useLocale, useTranslations } from 'next-intl'
import YouTubeIcon from '@mui/icons-material/YouTube'
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'

import { useAppSelector } from '@/src/redux/store'
import { selectAuth } from '@/src/redux/slices/authSlice'
import { HomepageFooter } from './homepageFooter'

const HomepageFooterWrapper: React.FC = () => {
    const locale = useLocale()
    const t = useTranslations('footer')
    const user = useAppSelector(selectAuth)

    // Social media links configuration
    const socialMediaLinks = [
        {
            name: 'youtube',
            href: 'https://www.youtube.com/user/FlyinVideos',
            icon: YouTubeIcon
        },
        {
            name: 'twitter',
            href: 'https://twitter.com/flyincom',
            icon: 'twitter' // Custom SVG
        },
        {
            name: 'instagram',
            href: 'https://www.instagram.com/flyincom/',
            icon: InstagramIcon
        },
        {
            name: 'facebook',
            href: 'https://www.facebook.com/flyin.com',
            icon: FacebookIcon
        },
        {
            name: 'linkedin',
            href: 'https://www.linkedin.com/company/flyin-com',
            icon: LinkedInIcon
        },
        {
            name: 'threads',
            href: 'https://www.threads.net/@flyincom',
            icon: 'threads'
        }
    ]

    // Company links
    const companyLinks = [
        { label: t('aboutUs'), href: `/aboutUs.${locale}.html` },
        { label: t('faqs'), href: `/faqs.${locale}.html` },
        { label: t('privacyPolicy'), href: `/privacyPolicy.${locale}.html` },
        { label: t('termsOfUse'), href: `/termsOfUse.${locale}.html` }
    ]

    // Support links
    const supportLinks = [
        { label: t('flyinWallet'), href: `/${locale}/wallet` },
        { label: t('contactUs'), href: `/contactUs.${locale}.html` },
        {
            label: t('addYourProperty'),
            href: 'https://extranet.flyin.com/?_gl=1*44oyfn*_gcl_au*Njk5NjI3OTgwLjE3NjQ5NDI4Njg.*_ga*ODU1MzYwMTExLjE3NjQ5NDI4Njg.*_ga_TKS3E29Q16*czE3NjQ5NDI4NjgkbzEkZzEkdDE3NjQ5NDMwMjQkajMwJGwwJGg3NDcyMzk5MDY.*_fplc*MmNBTDdMY1B6dGl2Q1pIbXZESG9wTnBFUUp6TEgwcjBsWUR3cGtPT0dodVR3RmYyaVYlMkJTQVNNRVR2ODMlMkJkeFBrdEdMUVlqemdCZkt2dm1rVUhOVENCcDZIJTJCUDB5UGlJTHFwdFJ0Rk1KTzNoUEtMdGwlMkI4eHpDbElPajNBJTJCZyUzRCUzRA..#/hotels/suppliers/edit',
            target: '_blank'
        },
        { label: 'Flyin Franchise', href: `/franchise/joinUs.en.html` }
    ]

    return (
        <HomepageFooter
            locale={locale}
            companyLinks={companyLinks}
            supportLinks={supportLinks}
            socialMediaLinks={socialMediaLinks}
            isSignedIn={user.signedIn}
        />
    )
}

export { HomepageFooterWrapper }
export default HomepageFooterWrapper
